import React from 'react';
import QRCode from 'qrcode.react';//引入生成二维码的库
import NHFetch from "../../utils/NHFetch";
import { Divider } from 'antd';

export default class QrCode extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            jumpUrl:''  //跳转地址
        }
    }

    componentDidMount(){
        NHFetch('api/sm-bpm-expansion/processdefine/getWfwlbUrl', 'GET', {wfwbz:"ZHXG_YDYX"})
            .then(res => {
                if (res) {
                    jumpUrl:res.data
                }
            })
    }

    render() {
        const { initData } = this.props;
        const { jumpUrl } = this.state;
        return (
            <div style={{display:'flex',justifyContent:'center'}}>
                <div className="result-example">
                    <div style={{ width: '300px',textAlign: 'left',fontSize:'17px',paddingLeft:'21%'}}>
                        <span style={{ display: 'block', marginTop: '6px' }}>{`学院：${initData.BMMC}`}</span>
                        <span style={{ display: 'block', marginTop: '6px' }}>{`专业：${initData.ZYMC}`}</span>
                        <span style={{ display: 'block', marginTop: '6px' }}>{`班级：${initData.BJMC}`}</span>
                    </div>
                    <Divider />
                    <div style={{textAlign: 'center'}}>
                        <QRCode
                            id="qrCode"
                            value={`${jumpUrl}/#/distributeClass?ServiceType=yxxt&bjid=${initData.BJID}`}  //value参数为生成二维码的值
                            size={180} //二维码的宽高尺寸
                            fgColor="#000000"  //二维码的颜色
                        />
                    </div>
                    <span style={{ width: '300px', display: 'block', textAlign: 'center', marginTop: '6px',fontSize:'21px' }}>请扫描二维码进行分班操作</span>
                </div>
                <style jsx="true" global="true">
                    {`
                          .result-example .spe {
                            width: 160px;
                            height: 160px;
                          }
                         .am-result .am-result-pic{
                            width: 160px;
                            height: 160px;
                         }
                    `}
                </style>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./components/distributeClass/qrCode.js